import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Growl } from 'primereact/growl';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import React, { Component } from 'react';
import { trackPromise } from 'react-promise-tracker';
import { HttpService } from '../../service/HttpService';
import { checkForError ,showMessage} from '../../utility/AppUtility';
import constant from './../../constant/Constant';
import {PriviladgeContext} from './../../context/priviladge-context'
import  CheckPriviladge from './../../hoc/CheckPriviladge'
import { AppBreadcrumb } from '../../AppBreadcrumb';

export class TemplateRequestList extends Component {

    constructor() {
        super();
        this.state = {
            dataTableValue: [],
            page: 1,
            totalRecords: 0,
            size: 100
        };

        this.httpService = new HttpService();
    }

    componentDidMount() {

        this.getList(this.state.page - 1);
    }
    getList = (page) => {
        trackPromise(
            this.httpService.getApi('templates/pending?page=' + page + "&size=" + this.state.size + "&sort=createdDate,desc").then((response) => {
                this.setState({ dataTableValue: response.data, totalRecords: response.data.totalElements });

            }).catch((error) => {
                if (checkForError(error))
                    this.showMessage('error', 'Error Message', error.response.data.title)
            }));
    }
    showMessage(severity, summary, message) {
        let msg = { severity: severity, summary: summary, detail: message };
        this.growl.show(msg);
    }
    onPageChange = (event) => {
        this.setState({ page: event.page })
        this.getList(event.page)

    }


    edit = (rowData) => {
        this.props.history.push({
            pathname: '/company_edit',
            state: { id: rowData.id }
        })
    }

    add = () => {
        this.props.history.push('company_add')
    }
    onCheckboxChange = (rowData) => {
        trackPromise(
            this.httpService.getApi('templates/change-status/' + rowData.id).then((response) => {
                this.getList(0);
            }).catch((error) => {

            }));
    }
    download = (rowData) => {
        var a = document.createElement('a');
        a.href = constant.MASTER_TEMPLATE_URl + rowData.name;
        a.download = rowData.name;
        a.target = '_blank';
        a.click();
        a.remove();
    }

    returnHeader = () => {
        return (
            <div>
                <div> List of template request</div>
                <div className="p-datatable-globalfilter-container">
                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Global Search" />

                </div>
            </div>
        );
    }
    actionTemplate = (rowData, column) => {
        return <div>
            <InputSwitch inputId={rowData.id} onChange={() => this.onCheckboxChange(rowData)} />
            <Button type="button" tooltip="Download" tooltipOptions={{ position: 'bottom' }} icon="pi-md-file-download" className="p-button-info" onClick={() => this.download(rowData)} style={{ marginRight: '.5em', marginLeft: "0.5em" }} />

        </div>;
    }
    render() {
        let actionHeader = <Button type="button" icon="pi-md-settings" />;

        return  <><div className="p-grid">
            <div className="p-col-12">
                <Growl ref={(el) => this.growl = el} style={{ marginTop: '75px' }} />

                <div className="card card-w-title datatable-demo">
                    <div className="p-col-12">
                        <font className="font21Weight500" >Template Request</font>
                    </div>
                    <div className="p-col-12">
                    </div>
                    <DataTable ref={(el) => this.dt = el} value={this.state.dataTableValue}
                        paginator={true} rows={10}
                        responsive={true} header="List of template request"
                      resizableColumns={true} columnResizeMode="fit"
                    >
                        <Column field="customer.name" header="Customer Name" headerStyle={{ fontWight: "600" }} sortable={true} filter={true} filterPlaceholder="Contains"  />
                        <Column field="customer.companyName" header="Company Name" headerStyle={{ fontWight: "600" }} sortable={true} filter={true} filterPlaceholder="Contains" />
                        <Column field="description" header="Description" headerStyle={{ fontWight: "600" }} sortable={true} filter={true} filterPlaceholder="Contains" />
                        <Column field="status" header="Status" headerStyle={{ fontWight: "600" }} sortable={true} filter={true} filterPlaceholder="Contains"  />
                        <Column header={actionHeader} body={this.actionTemplate} style={{ textAlign: 'center', width: '8em' }} />


                    </DataTable>

                </div>
            </div>
        </div></>
    }
}